import * as React from "react";
import { useJoinDrawer, useJoinDrawerUserExperience } from "../../providers";

import { LoginFormUi, LoginFormUiProps } from "../login-form-ui";

export interface StepLoginProps {
  useInitialState: LoginFormUiProps["useInitialState"];

  allowJoining?: boolean;
}
export const StepLogin: React.FunctionComponent<StepLoginProps> = (props) => {
  const { handleNotAMemberJoinForFree } = useJoinDrawerUserExperience();
  return (
    <section className="bbnt-common-join-drawer-fragment step-login">
      <img className="rewards-fancy-title-image" alt="REWARDS" />
      <h1 className="main-drawer-title">{`Sign In`}</h1>
      <p>{`Receive exclusive member pricing, save your wishlists, checkout faster, and much more.`}</p>

      <LoginFormUi useInitialState={props.useInitialState} />

      {props.allowJoining && (
        <NotAMemberJoinForFree
          handleNotAMemberJoinForFree={handleNotAMemberJoinForFree}
        />
      )}
    </section>
  );
};

interface NotAMemberJoinForFreeProps {
  handleNotAMemberJoinForFree: () => void;
}
const NotAMemberJoinForFree: React.FunctionComponent<
  NotAMemberJoinForFreeProps
> = (props) => {
  return (
    <React.Fragment>
      <p className="not-a-member-join-for-free">
        <span>{`Not a member? `}</span>
        <a
          onClick={props.handleNotAMemberJoinForFree}
          href="javascript:void(0)"
        >{`Join for free.`}</a>
      </p>
    </React.Fragment>
  );
};
